// extracted by mini-css-extract-plugin
export var divider = "_da-7";
export var itemsToggle = "_da-8";
export var mergeModal = "_da-1";
export var optionCard = "_da-4";
export var radioGroup = "_da-6";
export var radioOption = "_da-0";
export var selected = "_da-5";
export var shipmentOptions = "_da-2";
export var tableOptions = "_da-3";